import type { Partner } from '@/openapi';
import { PartnersService } from '@/openapi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/util/queryKeys';

export const useUpdatePartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (partner: Partner) => {
      await PartnersService.partnersServiceUpdatePartner({
        path: { id: partner.id },
        body: partner,
      });
    },
    onSettled: async (_data, _error, partner) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.partners.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.users.list() }),
        // If this partner has a user account, invalidate their specific details
        partner.account_id &&
          queryClient.invalidateQueries({
            queryKey: queryKeys.users.details(partner.account_id),
          }),
      ]);
    },
  });
};
